enum Alignment {
    CENTER = 'center',
    START = 'start',
    END = 'end',
    SPACE_AROUND= 'space_around',
    SPACE_BETWEEN= 'space_between'
}

export default Alignment;
